// extracted by mini-css-extract-plugin
export default {"wrapper":"notaryForm_wrapper__pgiut","grid":"notaryForm_grid__cntZl","gridItem":"notaryForm_gridItem__mMfCT","labelIcon":"notaryForm_labelIcon__b9wHn"};